// src/admin/config/onboardingSteps.js
//
// Single source of truth for onboarding steps, item labels, and where each
// item / "Let's go" button takes the user. Used by useOnboardingProgress and
// the welcome UI so list items can be links and the step button goes to the right place.

import { dashboardOpenUrl, DASHBOARD_OPEN, assetsOpenUrl, ASSETS_OPEN } from '../utils/openViewParams';

/**
 * Item id must match the completion key used in useOnboardingProgress (computeItems).
 * path: where the user goes when they click this item or when "Let's go" uses this step.
 */
export const ONBOARDING_STEPS_CONFIG = [
  {
    stepNumber: 1,
    category: 'GETTING STARTED',
    categoryColor: 'green',
    title: 'Basics',
    icon: 'bi bi-rocket-takeoff-fill',
    buttonText: "Let's go",
    /** Path for "Let's go" on this step (same as first item for step 1). */
    path: dashboardOpenUrl(DASHBOARD_OPEN.ASSIGN_TASK),
    items: [
      { id: 'assign_task', label: 'Assign a task to yourself', path: dashboardOpenUrl(DASHBOARD_OPEN.ASSIGN_TASK) },
      { id: 'complete_task', label: 'Complete the task', path: '/admin/tasks' },
    ],
  },
  {
    stepNumber: 2,
    category: 'ORGANIZATION',
    categoryColor: 'purple',
    title: 'Managing Things',
    icon: 'bi bi-sliders',
    buttonText: "Let's go",
    path: '/admin/tasks',
    items: [
      { id: 'add_asset', label: 'Add a new asset', path: '/admin/assets' },
      { id: 'create_workflow', label: 'Create a new workflow', path: '/admin/flows/' },
      { id: 'complete_new_workflow', label: 'Complete the new workflow', path: '/admin/tasks' },
      { id: 'invite_colleague', label: 'Invite a colleague', path: '/admin/users' },
    ],
  },
  {
    stepNumber: 3,
    category: 'ANALYTICS',
    categoryColor: 'teal',
    title: 'Reporting',
    icon: 'bi bi-graph-up-arrow',
    buttonText: "Let's go",
    lockedMessage: 'Complete step 2 first',
    path: '/admin/reports/tasks',
    items: [
      { id: 'visited_work_record', label: 'Check out the work record', path: assetsOpenUrl(ASSETS_OPEN.TASK_REPORT) },
      { id: 'visited_reports', label: 'Check out the reports', path: '/admin/reports/tasks' },
    ],
  },
];
